import React from "react";
import { Box, Button, Typography } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import { fileUploaderTypes } from "../Uploader/uploadFileTypes";

// Reuses the same sample files already linked from the Inventory/Clients
// bulk-upload "Uploader" component rather than a second, possibly-drifting
// copy of each URL.
function SampleFileCard({ type = "clients" }) {
  const { sampleFileLink, sampleFileName, title } = fileUploaderTypes[type] || fileUploaderTypes.clients;

  return (
    <div className="ticket-status-card">
      <Box display="flex" alignItems="center" gap={1}>
        <InsertDriveFileIcon color="action" />
        <Box flex={1} minWidth={0}>
          <Typography variant="body2" fontWeight={600} noWrap>
            {sampleFileName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Template for {title.toLowerCase()}
          </Typography>
        </Box>
      </Box>
      <Button
        component="a"
        href={sampleFileLink}
        target="_blank"
        rel="noopener noreferrer"
        variant="outlined"
        size="small"
        startIcon={<DownloadIcon />}
        sx={{ mt: 1.5, textTransform: "none" }}
        fullWidth
      >
        Download Sample File
      </Button>
    </div>
  );
}

export default SampleFileCard;
